export default __webpack_public_path__ + "static/media/document.570dc3e9.svg";